import React from "react";
import AccountSummary from "../../features/account-summary/accountSummary";
import AddressManager from "../../features/address-manager/addressmanagerList";
import AgentsList from "../../features/agents-list/agentsList";
import AgingInvoices from "../../features/invoices/aging-invoices/agingInvoices";
import AnnouncementManagement from "../../features/announcement/management";
import ReleaseDetailsList from "../../features/release-details/releaseDetailsList";
import ReleaseDetailsPage from "../../features/release-details/releaseDetailsPage";
import AuthCallbackReceiver from "../../features/auth/callbackReceiver";
import BolCombined from "../../features/bol";
import BolCreate from "../../features/bol/bol-only/create";
import BolList from "../../features/bol/bol-only/list";
import ClaimList from "../../features/claims/list";
import ClaimCreate from "../../features/claims/create";
import CompanySettings from "../../features/company-settings/companySettings";
import ConfirmData from "../../features/login/confirm-data/confirmData";
import ConfirmDataValidate from "../../features/login/confirm-data/confirmDataValidate";
import Carriers from "../../features/carriers/carriers";
import CustomersList from "../../features/customers/list/customersList";
import CustomersUsers from "../../features/company/users-list/usersList";
import DeliveryRecordsList from "../../features/shipments/delivery-records/deliveryRecordsList";
import DeliveryRecordsNew from "../../features/shipments/delivery-records/deliveryRecordsNew";
import LoadboardDispatchList from "../../features/loadboard-dispatch/loadboardDispatchList";
import DockLoadingList from "../../features/dock-loading/dockLoadingList";
import EmailConfirm from "../../features/settings/email-confirm/emailConfirm";
import EmployeeHome from "../../features/home/employee/employeeHome";
import Equipment from "../../features/equipment/equipment";
import RouteGuide from "../../features/route-guide/routeGuide";
import FeatureBannerManagement from "../../features/feature-banner/management";
import PaymentSettings from "../../features/payment-settings/paymentSettings";
import PaymentReturn from "../../features/invoices/invoice-payment/paymentReturn";
import PaymentsList from "../../features/payments/paymentsList";
import PaymentReceiptPage from "../../features/payments/paymentReceiptPage";
import PaymentAdminBrowser from "../../features/payments/paymentAdminBrowser";
import ForgotPassword from "../../features/login/forgot-password/forgotPassword";
import GuidedRequestRates from "../../features/rates/guidedRequestRates";
import InvoiceDetails from "../../features/invoices/invoice-details/invoiceDetails";
// import JWTGenerator from "../../features/admin/jwt-generator/jwtGenerator";
import PendingRequests from "../../features/customers/pending/pendingRequests";
import PickupCreate from "../../features/pickup/create";
import PickupManagement from "../../features/pickup/management";
import PickupManagementV2 from "../../features/pickup/management-v2";
import PickupLog from "../../features/pickup/log";
import PickupInboxPage from "../../features/pickup/inbox";
import PickupInboxAnalyticsPage from "../../features/pickup/inbox/analytics";
import PickupSummary from "../../features/pickup/summary";
import PodRecognition from "../../features/documents/podRecognition/podRecognition";
import PortalRegistration from "../../features/login/portal-registration/portalRegistration";
import PublicShipmentDetails from "../../features/shipments/public-shipment-details/publicShipmentDetails";
import RecognitionLogs from "../../features/documents/recognitionLogs/recognitionLogs";
import ReportDetails from "../../features/reports/scheduled/report-details/reportDetails";
import ReportUnsubscribe from "../../features/reports/scheduled/unsubscribe/reportUnsubscribe";
import ResetPassword from "../../features/login/reset-password/resetPassword";
import ReturnCreate from "../../features/bol/return/create";
import ReturnList from "../../features/bol/return/list";
import CustomerPickupsList from "../../features/bol/pickups/customerPickupsList";
import RatesDetails from "../../features/rates/ratesDetails";
import RatesList from "../../features/rates/ratesList";
import QuickRequestRates from "../../features/rates/quickRequestRates";
import ScheduledReports from "../../features/reports/scheduled/scheduledReports";
import Settings from "../../features/settings/settings";
import ShipmentDetails from "../../features/shipments/shipment-details/shipmentDetails";
import ShipmentsDocuments from "../../features/shipments/documents/documents";
import LabelsReceipts from "../../features/shipments/labels-receipts/labelsReceipts";
import SignupByInvite from "../../features/signup-by-invite/signupByInvite";
import Tracking from "../../features/shipments/tracking/tracking";
import TerminalSummary from "../../features/terminal-summary/terminalSummary";
import TransitCalculator from "../../features/transit-calculator/transitCalculator";
import UserProfile from "../data/user/UserProfile";
import EmergencyAlertManagement from "../../features/emergency-alert/emergencyAlertManagement";
import { AgingInvoicesPath } from "../../features/invoices/aging-invoices/route";
import { ClaimsPath } from "../../features/claims/route";
import { CompanySettingsPath } from "../../features/company-settings/route";
import { DataConfirmPath } from "../../features/login/confirm-data/route";
import { EmailConfirmPath } from "../../features/settings/email-confirm/route";
import { InvoiceDetailsPath } from "../../features/invoices/invoice-details/route";
import { PickupLogPath } from "../../features/pickup/log/route";
import { PickupInboxPath } from "../../features/pickup/inbox/route";
import { PublicShipmentDetailsPath } from "../../features/shipments/public-shipment-details/route";
import { RatesPath } from "../../features/rates/route";
import { ReportsPath } from "../../features/reports/route";
import { ResetPasswordPath } from "../../features/login/reset-password/route";
import { SettingsPath } from "../../features/settings/route";
import { ShipmentDetailsPath } from "../../features/shipments/shipment-details/route";
import { SignupByInvitePath } from "../../features/signup-by-invite/route";
import { TrackShipmentsPath } from "../../features/shipments/tracking/route";
import { UserUtils } from "../data/user/userUtils";
import { ManifestDocuments } from "../../features/shipments/manifest-documents/manifestDocuments";
import { HolidayCalendar } from "../../features/holiday-calendar/holidayCalendar";
import { RpgAnalyzer } from "../../features/rpg-analyzer/rpgAnalyzer";
import { ManifestsView } from '../../features/manifest/manifestsView'
import { LinehaulMileage } from "../../features/linehaul-mileage";
import { LinehaulLaneManagement } from "../../features/linehaul-mileage/linehaulLaneManagement";
import { LinehaulOutboundPlanning } from "../../features/linehaul-outbound-planning";
import { AppointmentSummary } from "../../features/appointment/appointmentSummary";
import PlanProbills from "../../features/dispatch/plan-probills/planProbills";
import ActiveRoutes from "../../features/dispatch/route/activeRoutes";
import Picklists from "../../features/dispatch/picklists/picklists";
import { PickupsPath } from "../../features/bol/route";
import UnplannableProbills from "../../features/dispatch/unplannable-probills/unplannableProbills";
import ShipmentChat from "../../features/ai/shipment-chat/shipmentChat";
import { WarehouseSummary } from "../../features/warehouse-inventory/warehouseSummary";
import { CustomerInventory } from "../../features/warehouse-inventory/customerInventory";
import { InboundPickupSummary } from "../../features/pickup/inbound-pickups/summary";
import { InboundPickups } from "../../features/pickup/inbound-pickups/inboundPickups";
import InboundFreights from "../../features/freights/inbound/inboundFreights";
import ServiceDisruption from "../../features/dispatch/service-disruption/serviceDisruption";
import { PickupApprovement } from "../../features/pickup-approval";
import TerminalInsights from "../../features/terminal-insights";
import TerminalDetails from "features/terminal-details/terminalDetails";
import { TerminalSummaryPath } from "features/terminal-details/route";
import OperationsReview from "../../features/shipment-reconciliation/operations-review/operationsReview";
import BillingReview from "../../features/shipment-reconciliation/billing-review/billingReview";
import AccessorialsReviewDashboard from "features/shipment-reconciliation/dashboard/accessorial-review/accessorialReviewDashbaord";
import AccessorialRevenueInsights from "features/shipment-reconciliation/revenue-insights/accessorialRevenueInsights";
import CallTranscripts from "../../features/customer-service/call-transcripts/callTranscripts";
import PickupCreateQuick from "features/pickup/create/create-quick/pickupCreateQuick";
import DriversList from "features/drivers/driversList";
import DockUsersList from "features/dock-scan-management/dockUsersList";
import DockScanLogsList from "features/dock-scan-management/dockScanLogsList";
import DockAuthAuditList from "features/dock-scan-management/dockAuthAuditList";
import CloneWeek from "features/static-load/cloneWeek";
import CityDeliveryDispatchBoard from "features/city-delivery/dispatch-board/cityDeliveryDispatchBoard";
import LinehaulScheduler from "features/static-load/linehaulScheduler";

export const Routes = {
  home: "/",
  authCallback: "/auth-callback",
  customerService: {
    callTranscripts: "/customer-service/call-transcripts"
  },
  terminalInsights: "/daily-overview",
  forgotPassword: "/forgot-password",
  portalRegistration: "/portal-registration",
  confirmData: "/confirm-data",
  invoices: "/invoices",
  agingInvoices: "/aging-invoices",
  claims: {
    list: "/claims",
    create: "/claims/create",
  },
  shipments: {
    documents: "/documents-download",
    labelsReceipts: "/labels-receipts",
    manifestDocuments: "/manifest-documents",
    filteredList: "/shipments-filtered",
    inProgress: "/in-progress",
    publicDetails: "/shipment-tracking",
    recent: "/shipments/recent",
    tracking: "/shipments",
    appointments: "/appointments"
  },
  deliveryRecords: {
    list: "/delivery-records",
    new: "/delivery-records/new"
  },
  settings: "/settings",
  users: {
    resetPassword: "/users/reset-password",
    signupByInvite: "/users/invite",
    emailConfirm: "/users/email-confirm",
    dataConfirm: "/users/confirm",
    list: "/users/list"
  },
  addressManager: {
    list: "/addressManager/list"
  },
  driversList: {
    list: "/drivers/list"
  },
  dockUsers: {
    list: "/dock-users/list"
  },
  dockScanLogs: {
    list: "/dock-scan-logs/list"
  },
  dockAuthAudit: {
    list: "/dock-auth-audit/list"
  },
  terminalSummary: {
    list: "/terminals/list",
  },
  equipment: {
    list: "/equipment/list",
  },
  routeGuide: {
    list: "/route-guide/list",
  },
  carriers: {
    list: "/carriers/list",
  },
  customers: {
    pending: "/customers/pending",
    list: "/customers/list",
  },
  agents: {
    list: "/agents/list"
  },
  announcement: "/announcement",
  releaseDetails: "/release-details",
  featureBanner: "/feature-banner",
  paymentSettings: "/payment-settings",
  paymentReturn: "/payments/return",
  paymentHistory: "/payments/history",
  paymentReceipt: "/payments/receipt",
  paymentAdmin: "/payments/admin",
  admin: {
    // jwtGenerator: "/admin/generate-jwt"
  },
  reports: {
    scheduled: {
      list: "/reports/scheduled",
      create: "/reports/scheduled/create",
      unsubscribe: "/unsubscribe/report"
    }
  },
  rates: {
    list: "/rates",
    guided: "/rates/guided-request",
    quick: "/rates/quick-request"
  },
  company: {
    general: "/company"
  },
  bol: {
    list: "/bol-only",
    create: "/bol-only/create"
  },
  requestPickup: {
    root: "/request-pickup",
    create: "/request-pickup/create"
  },
  bolCombined: "/bol-all",
  pickup: {
    create: "/pickup/create",
    log: "/pickup/log",
    management: "/pickup/management",
    managementV2: "/pickup/assignment-v2",
    summary: "/pickup/summary",
    inboundSummary: '/pickup/outbound/summary',
    inboundPickups: '/pickup/outbound/list',
    quickCreate: "/pickup/quick-create",
    inbox: "/pickup/inbox",
    inboxAnalytics: "/pickup/inbox/analytics"
  },
  pickups: {
    list: "/pickups",
  },
  return: {
    list: "/return",
    create: "/return/create",
  },
  transitCalculator: "/transit-calculator",
  holidayCalendar: "/holiday-calendar",
  rpgAnalyzer: "/rpg-analyzer",
  manifest: {
    manifests: "/manifest/manifests"
  },
  linehaulMileage: {
    mileage: "/linehaul-mileage/trips",
    management: "/linehaul-mileage/lanes"
  },
  linehaulOutboundPlanning: "/linehaul/outbound-planning",
  dispatch: {
    activeRoutes: "/dispatch/active-routes",
    planRoute: "/dispatch/route/plan",
    picklists: "/dispatch/picklists",
    unplannableProbills: "/dispatch/unplannable/probills",
    serviceDisruption: "/dispatch/service/disruption",
  },
  ai: {
    shipmentChat: "/ai/shipment-chat",
  },
  warehouseInventory: {
    summary: "/warehouse-inventory/summary",
    inventory: "/warehouse-inventory/inventory"
  },
  documents: {
    podRecognition: "/documents/pod-recognition",
    recognitionLogs: "/documents/recognition-logs"
  },
  loadboarddispatch: {
    list: "/loadboard-dispatch"
  },
  dockLoading: {
    list: "/dock-loading"
  },
  billing: {
    pickupApproval: "/pickup-processing"
  },
  shipmentReconciliation: {
    operationsReview: "/shipment-reconciliation/operations-review",
    billingReview: "/shipment-reconciliation/billing-review",
    accessorialReviewDashbaord: "/shipment-reconciliation/dashboard/accessorial-review",
    accessorialRevenueInsights: "/shipment-reconciliation/accessorial-revenue-insights"
  },
  emergencyAlertManagement: "/emergency-alert",
  staticLoad: {
    list: "/static-load",
    manageSchedules: "/static-load/manage-schedules",
    dashboard: "/static-load/dashboard"
  },
  freights: {
    inbound: "/freights/inbound"
  },
  cityDelivery: {
    dispatchBoard: "/city-delivery/dispatch-board"
  }
};

export const accountNumberParamName = "accountNumber";

export interface CoreAccountPathParams {
  [accountNumberParamName]: string;
};

export const getPathWithCoreAccountParams = (route: string) => {
  return `/:${accountNumberParamName}${route === Routes.home ? "" : route}`;
};

export const getPathWithAccountNumber = (route: string) => {
  const paths = [getPathWithCoreAccountParams(route), route];
  return paths;
};

export const terminalNumberParamName = "terminalNumber";

export interface CoreTerminalPathParams {
  [terminalNumberParamName]: string;
};

export const getPathWithCoreTerminalParams = (route: string) => {
  return `/:${terminalNumberParamName}${route === Routes.home ? "" : route}`;
};

export const getPathWithTerminalNumber = (route: string) => {
  const paths = [getPathWithCoreTerminalParams(route), route];
  return paths;
};

export enum FEATURE {
  CUSTOMER_SERVICE = "CUSTOMER_SERVICE",
  RETURNS = "RETURNS",
  LINEHAUL_MANAGEMENT = "LINEHAUL_MANAGEMENT",
  ANNOUNCEMENTS = "ANNOUNCEMENTS",
  ACCESSORIAL_ANALYTICS = "ACCESSORIAL_ANALYTICS",
  ACCESSORIAL_BILLING_REVIEW = "ACCESSORIAL_BILLING_REVIEW",
}

export interface RoutesComponent {
  path: string | string[];
  component: React.FC<any>;
  fixedPath?: string;
  exact?: boolean;
  isPrivate?: boolean;
  includeAccountNumberInUrl?: boolean;
  feature?: FEATURE;
}

export const publicRoutesComponents: RoutesComponent[] = [
  {
    path: Routes.authCallback,
    component: AuthCallbackReceiver
  },
  {
    fixedPath: Routes.users.resetPassword,
    path: `${Routes.users.resetPassword}/:${ResetPasswordPath.token}`,
    component: ResetPassword
  },
  {
    fixedPath: Routes.users.signupByInvite,
    path: `${Routes.users.signupByInvite}/:${SignupByInvitePath.token}`,
    component: SignupByInvite
  },
  {
    path: Routes.forgotPassword,
    component: ForgotPassword
  },
  {
    path: Routes.portalRegistration,
    component: PortalRegistration
  },
  {
    path: Routes.confirmData,
    component: ConfirmData
  },
  {
    fixedPath: Routes.users.dataConfirm,
    path: `${Routes.users.dataConfirm}/:${DataConfirmPath.token}`,
    component: ConfirmDataValidate
  },
  {
    fixedPath: Routes.users.emailConfirm,
    path: `${Routes.users.emailConfirm}/:${EmailConfirmPath.token}`,
    component: EmailConfirm
  },
  {
    fixedPath: Routes.shipments.publicDetails,
    path: `${Routes.shipments.publicDetails}/:${PublicShipmentDetailsPath.probill}`,
    component: PublicShipmentDetails
  },
  {
    fixedPath: Routes.reports.scheduled.unsubscribe,
    path: `${Routes.reports.scheduled.unsubscribe}/:${ReportsPath.id}/:${ReportsPath.email}`,
    component: ReportUnsubscribe
  },
];

// {
//   path: getPathWithAccountNumber(Routes.admin.jwtGenerator),
//   component: JWTGenerator,
//   isPrivate: true,
//   exact: true,
//   includeAccountNumberInUrl: true
// }

const customerViewRoutesComponents: RoutesComponent[] = [
  {
    path: getPathWithAccountNumber(Routes.home),
    component: AccountSummary,
    exact: true,
    isPrivate: true,
    includeAccountNumberInUrl: true,
  },
  {
    path: getPathWithAccountNumber(`${Routes.releaseDetails}/:id`),
    component: ReleaseDetailsPage,
    exact: true,
    isPrivate: true,
    includeAccountNumberInUrl: true,
  },
  {
    path: getPathWithAccountNumber(Routes.releaseDetails),
    component: ReleaseDetailsList,
    exact: true,
    isPrivate: true,
    includeAccountNumberInUrl: true,
  },
  {
    path: [
      ...getPathWithAccountNumber(`${Routes.shipments.tracking}/:${ShipmentDetailsPath.invoiceNumber}/:${ShipmentDetailsPath.activeTab}`),
      ...getPathWithAccountNumber(`${Routes.shipments.tracking}/:${ShipmentDetailsPath.invoiceNumber}`)
    ],
    component: ShipmentDetails,
    isPrivate: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(Routes.shipments.tracking),
    component: Tracking,
    exact: true,
    isPrivate: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(Routes.terminalSummary.list),
    component: TerminalSummary,
    exact: true,
    isPrivate: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(`${Routes.terminalSummary.list}/:${TerminalSummaryPath.number}`),
    component: TerminalDetails,
    exact: true,
    isPrivate: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithTerminalNumber(Routes.driversList.list),
    component: DriversList,
    isPrivate: true,
    exact: true
  },
  {
    path: [
      ...getPathWithAccountNumber(`${Routes.settings}/:${SettingsPath.activeTab}`),
      ...getPathWithAccountNumber(Routes.settings)
    ],
    component: Settings,
    exact: true,
    isPrivate: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(Routes.reports.scheduled.list),
    component: ScheduledReports,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(Routes.reports.scheduled.create),
    component: ReportDetails,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(`${Routes.reports.scheduled.list}/:${ReportsPath.id}`),
    component: ReportDetails,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true
  },
  {
    path: [
      ...getPathWithAccountNumber(`${Routes.company.general}/:${CompanySettingsPath.activeTab}/:${CompanySettingsPath.selectedItem}/:${CompanySettingsPath.innerTab}`),
      ...getPathWithAccountNumber(`${Routes.company.general}/:${CompanySettingsPath.activeTab}/:${CompanySettingsPath.selectedItem}`),
      ...getPathWithAccountNumber(`${Routes.company.general}/:${CompanySettingsPath.activeTab}`),
      ...getPathWithAccountNumber(Routes.company.general)
    ],
    component: CompanySettings,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(Routes.bolCombined),
    component: BolCombined,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(Routes.bol.list),
    component: BolList,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(Routes.bol.create),
    component: BolCreate,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(Routes.requestPickup.create),
    component: BolCreate,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(Routes.return.list),
    component: ReturnList,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true,
    feature: FEATURE.RETURNS,
  },
  {
    path: getPathWithAccountNumber(Routes.return.create),
    component: ReturnCreate,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true,
    feature: FEATURE.RETURNS,
  },
  {
    path: getPathWithAccountNumber(Routes.pickups.list),
    component: CustomerPickupsList,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(`${Routes.pickups.list}/:${PickupsPath.pickupNumber}`),
    component: CustomerPickupsList,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(Routes.shipments.documents),
    component: ShipmentsDocuments,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(Routes.claims.list),
    component: ClaimList,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(Routes.claims.create),
    component: ClaimCreate,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(`${Routes.claims.list}/:${ClaimsPath.number}`),
    component: ClaimList,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(Routes.transitCalculator),
    component: TransitCalculator,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(Routes.paymentReturn),
    component: PaymentReturn,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true,
  },
  {
    fixedPath: Routes.users.emailConfirm,
    path: `${Routes.users.emailConfirm}/:${EmailConfirmPath.token}`,
    component: EmailConfirm
  },
  {
    path: Routes.warehouseInventory.summary,
    component: WarehouseSummary,
    exact: true,
    isPrivate: true
  },
  {
    path: Routes.warehouseInventory.inventory,
    component: CustomerInventory,
    exact: true,
    isPrivate: true
  },
];

const customerRateQuotesRoutesComponents: RoutesComponent[] = [
  {
    path: getPathWithAccountNumber(Routes.rates.list),
    component: RatesList,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(Routes.rates.guided),
    component: GuidedRequestRates,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(Routes.rates.quick),
    component: QuickRequestRates,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true
  },
  {
    path: getPathWithAccountNumber(`${Routes.rates.list}/:${RatesPath.id}`),
    component: RatesDetails,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true
  }
];

const customerPaymentRoutesComponents: RoutesComponent[] = [
  {
    path: getPathWithAccountNumber(`${Routes.agingInvoices}/:${AgingInvoicesPath.period}`),
    component: AgingInvoices,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true,
  },
  {
    path: getPathWithAccountNumber(`${Routes.invoices}/:${InvoiceDetailsPath.invoiceNumber}`),
    component: InvoiceDetails,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true,
  },
  {
    path: getPathWithAccountNumber(Routes.paymentReturn),
    component: PaymentReturn,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true,
  },
  {
    path: getPathWithAccountNumber(Routes.paymentHistory),
    component: PaymentsList,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true,
  },
  {
    path: getPathWithAccountNumber(`${Routes.paymentReceipt}/:paymentId`),
    component: PaymentReceiptPage,
    isPrivate: true,
    exact: true,
    includeAccountNumberInUrl: true,
  },
];

const customerWOPermissionsRoutesComponents: RoutesComponent[] = [
  {
    path: Routes.home,
    component: AccountSummary,
    exact: true,
    isPrivate: true,
    includeAccountNumberInUrl: false
  },
  {
    path: getPathWithAccountNumber(Routes.paymentReturn),
    component: PaymentReturn,
    isPrivate: true,
    exact: true,
  },
  {
    path: [
      `${Routes.settings}/:${SettingsPath.activeTab}`,
      Routes.settings
    ],
    component: Settings,
    exact: true,
    isPrivate: true
  },
  {
    path: Routes.company.general,
    component: CompanySettings,
    exact: true,
    isPrivate: true
  },
  {
    path: `${Routes.releaseDetails}/:id`,
    component: ReleaseDetailsPage,
    exact: true,
    isPrivate: true
  },
  {
    path: Routes.releaseDetails,
    component: ReleaseDetailsList,
    exact: true,
    isPrivate: true
  },
];

export const xgsUserRoutesComponents: RoutesComponent[] = [
  {
    path: getPathWithTerminalNumber(Routes.customerService.callTranscripts),
    component: CallTranscripts,
    exact: true,
    isPrivate: true,
    feature: FEATURE.CUSTOMER_SERVICE
  },
  {
    path: getPathWithTerminalNumber(Routes.pickup.quickCreate),
    component: PickupCreateQuick,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.pickup.create),
    component: PickupCreate,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.pickup.inboxAnalytics),
    component: PickupInboxAnalyticsPage,
    isPrivate: true,
    exact: true
  },
  {
    path: [
      ...getPathWithTerminalNumber(`${Routes.pickup.inbox}/:${PickupInboxPath.messageId}`),
      ...getPathWithTerminalNumber(Routes.pickup.inbox)
    ],
    component: PickupInboxPage,
    isPrivate: true,
    exact: true
  },
  {
    path: [
      ...getPathWithTerminalNumber(`${Routes.pickup.log}/:${PickupLogPath.pickupNumber}`),
      ...getPathWithTerminalNumber(Routes.pickup.log)
    ],
    component: PickupLog,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.pickup.management),
    component: PickupManagement,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.pickup.managementV2),
    component: PickupManagementV2,
    isPrivate: true,
    exact: true
  },
  {
    path: [
      ...getPathWithTerminalNumber(Routes.pickup.summary)
    ],
    component: PickupSummary,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.shipments.documents),
    component: ShipmentsDocuments,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.shipments.labelsReceipts),
    component: LabelsReceipts,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.shipments.manifestDocuments),
    component: ManifestDocuments,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.deliveryRecords.list),
    component: DeliveryRecordsList,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.deliveryRecords.new),
    component: DeliveryRecordsNew,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.terminalSummary.list),
    component: TerminalSummary,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(`${Routes.terminalSummary.list}/:${TerminalSummaryPath.number}`),
    component: TerminalDetails,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.addressManager.list),
    component: AddressManager,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.driversList.list),
    component: DriversList,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.dockUsers.list),
    component: DockUsersList,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.dockScanLogs.list),
    component: DockScanLogsList,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.dockAuthAudit.list),
    component: DockAuthAuditList,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.carriers.list),
    component: Carriers,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.equipment.list),
    component: Equipment,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.routeGuide.list),
    component: RouteGuide,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.customers.list),
    component: CustomersList,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.agents.list),
    component: AgentsList,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.users.list),
    component: CustomersUsers,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.customers.pending),
    component: PendingRequests,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(`${Routes.releaseDetails}/:id`),
    component: ReleaseDetailsPage,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.releaseDetails),
    component: ReleaseDetailsList,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.announcement),
    component: AnnouncementManagement,
    isPrivate: true,
    exact: true,
    feature: FEATURE.ANNOUNCEMENTS,
  },
  {
    path: getPathWithTerminalNumber(Routes.featureBanner),
    component: FeatureBannerManagement,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.paymentReturn),
    component: PaymentReturn,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(`${Routes.paymentReceipt}/:paymentId`),
    component: PaymentReceiptPage,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.holidayCalendar),
    component: HolidayCalendar,
    isPrivate: true,
    exact: true
  },
  {
    path: [
      ...getPathWithTerminalNumber(`${Routes.shipments.tracking}/:${ShipmentDetailsPath.invoiceNumber}/:${ShipmentDetailsPath.activeTab}`),
      ...getPathWithTerminalNumber(`${Routes.shipments.tracking}/:${ShipmentDetailsPath.invoiceNumber}`)
    ],
    component: ShipmentDetails,
    isPrivate: true
  },
  {
    path: getPathWithTerminalNumber(`${Routes.shipments.filteredList}/:${TrackShipmentsPath.accountNumber}/:${TrackShipmentsPath.shipmentGroup}`),
    component: Tracking,
    isPrivate: true
  },
  {
    path: getPathWithTerminalNumber(Routes.shipments.tracking),
    component: Tracking,
    isPrivate: true
  },
  {
    path: getPathWithTerminalNumber(Routes.shipments.recent),
    component: Tracking,
    exact: true,
    isPrivate: true
  },
  {
    path: getPathWithTerminalNumber(Routes.shipments.inProgress),
    component: Tracking,
    exact: true,
    isPrivate: true
  },
  {
    path: [
      ...getPathWithTerminalNumber(`${Routes.settings}/:${SettingsPath.activeTab}`),
      ...getPathWithTerminalNumber(Routes.settings)
    ],
    component: Settings,
    exact: true,
    isPrivate: true
  },
  {
    path: getPathWithTerminalNumber(Routes.manifest.manifests),
    component: ManifestsView,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.linehaulMileage.mileage),
    component: LinehaulMileage,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.linehaulMileage.management),
    component: LinehaulLaneManagement,
    isPrivate: true,
    exact: true,
    feature: FEATURE.LINEHAUL_MANAGEMENT,
  },
  {
    path: getPathWithTerminalNumber(Routes.linehaulOutboundPlanning),
    component: LinehaulOutboundPlanning,
    isPrivate: true,
    exact: true,
  },
  {
    path: getPathWithTerminalNumber(Routes.shipments.appointments),
    component: AppointmentSummary,
    exact: true,
    isPrivate: true
  },
  {
    path: getPathWithTerminalNumber(Routes.dispatch.planRoute),
    component: PlanProbills,
    exact: true,
    isPrivate: true,
  },
  {
    path: getPathWithTerminalNumber(Routes.dispatch.activeRoutes),
    component: ActiveRoutes,
    exact: true,
    isPrivate: true,
  },
  {
    path: getPathWithTerminalNumber(Routes.dispatch.picklists),
    component: Picklists,
    exact: true,
    isPrivate: true
  },
  {
    path: getPathWithTerminalNumber(Routes.dispatch.unplannableProbills),
    component: UnplannableProbills,
    exact: true,
    isPrivate: true
  },
  {
    path: getPathWithTerminalNumber(Routes.ai.shipmentChat),
    component: ShipmentChat,
    exact: true,
    isPrivate: true
  },
  {
    path: getPathWithTerminalNumber(`${Routes.ai.shipmentChat}/:probillNumber`),
    component: ShipmentChat,
    exact: true,
    isPrivate: true
  },
  {
    path: getPathWithTerminalNumber(Routes.documents.podRecognition),
    component: PodRecognition,
    exact: true,
    isPrivate: true
  },
  {
    path: getPathWithTerminalNumber(Routes.documents.recognitionLogs),
    component: RecognitionLogs,
    exact: true,
    isPrivate: true
  },
  {
    path: getPathWithTerminalNumber(Routes.loadboarddispatch.list),
    component: LoadboardDispatchList,
    exact: true,
    isPrivate: true
  },
  {
    path: getPathWithTerminalNumber(Routes.dockLoading.list),
    component: DockLoadingList,
    exact: true,
    isPrivate: true
  },
  {
    path: getPathWithTerminalNumber(Routes.dispatch.serviceDisruption),
    component: ServiceDisruption,
    exact: true,
    isPrivate: true
  },
  {
    path: getPathWithTerminalNumber(Routes.emergencyAlertManagement),
    component: EmergencyAlertManagement,
    exact: true,
    isPrivate: true
  },
  {
    path: getPathWithTerminalNumber(Routes.shipmentReconciliation.operationsReview),
    component: OperationsReview,
    exact: true,
    isPrivate: true
  },
  {
    path: getPathWithTerminalNumber(Routes.shipmentReconciliation.billingReview),
    component: BillingReview,
    exact: true,
    isPrivate: true,
    feature: FEATURE.ACCESSORIAL_BILLING_REVIEW
  },
  {
    path: getPathWithTerminalNumber(Routes.terminalSummary.list),
    component: TerminalSummary,
    exact: true,
    isPrivate: true
  },
  {
    path: getPathWithTerminalNumber(`${Routes.terminalSummary.list}/:${TerminalSummaryPath.number}`),
    component: TerminalDetails,
    exact: true,
    isPrivate: true
  },
  {
    path: getPathWithTerminalNumber(Routes.shipmentReconciliation.accessorialReviewDashbaord),
    component: AccessorialsReviewDashboard,
    exact: true,
    isPrivate: true,
    feature: FEATURE.ACCESSORIAL_ANALYTICS
  },
  {
    path: getPathWithTerminalNumber(Routes.shipmentReconciliation.accessorialRevenueInsights),
    component: AccessorialRevenueInsights,
    exact: true,
    isPrivate: true,
    feature: FEATURE.ACCESSORIAL_ANALYTICS
  },
  {
    path: getPathWithTerminalNumber(Routes.cityDelivery.dispatchBoard),
    component: CityDeliveryDispatchBoard,
    exact: true,
    isPrivate: true
  },
  {
    // should be the last one in the array!
    path: getPathWithTerminalNumber(Routes.home),
    component: EmployeeHome,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(`${Routes.pickup.inboundSummary}`),
    component: InboundPickupSummary,
    isPrivate: true,
    exact: true,
  },
  {
    path: getPathWithTerminalNumber(`${Routes.pickup.inboundPickups}`),
    component: InboundPickups,
    isPrivate: true,
    exact: true,
  },
  {
    path: getPathWithTerminalNumber(`${Routes.staticLoad.list}`),
    component: LinehaulScheduler,
    exact: true,
    isPrivate: true,
  },
  {
    path: getPathWithTerminalNumber(`${Routes.staticLoad.manageSchedules}`),
    component: CloneWeek,
    exact: true,
    isPrivate: true,
  },
  {
    path: getPathWithTerminalNumber(`${Routes.freights.inbound}`),
    component: InboundFreights,
    isPrivate: true,
    exact: true,
  },
  {
    path: getPathWithTerminalNumber(`${Routes.billing.pickupApproval}`),
    component: PickupApprovement,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.terminalInsights),
    component: TerminalInsights,
    exact: true,
    isPrivate: true
  }
];

const xgsDriverRoutesComponents: RoutesComponent[] = [
  {
    path: Routes.home,
    component: DeliveryRecordsList,
    exact: true,
    isPrivate: true
  },
  {
    path: Routes.deliveryRecords.list,
    component: DeliveryRecordsList,
    isPrivate: true,
    exact: true
  },
  {
    path: Routes.deliveryRecords.new,
    component: DeliveryRecordsNew,
    isPrivate: true,
    exact: true
  },
  {
    path: [
      `${Routes.settings}/:${SettingsPath.activeTab}`,
      Routes.settings
    ],
    component: Settings,
    exact: true,
    isPrivate: true
  }
];

const financePaymentRoutesComponents: RoutesComponent[] = [
  {
    path: getPathWithTerminalNumber(Routes.paymentSettings),
    component: PaymentSettings,
    isPrivate: true,
    exact: true
  },
  {
    path: getPathWithTerminalNumber(Routes.paymentAdmin),
    component: PaymentAdminBrowser,
    isPrivate: true,
    exact: true
  },
];

const rpgAnalyzerRouteComponent: RoutesComponent[] = [
  {
    path: getPathWithTerminalNumber(Routes.rpgAnalyzer),
    component: RpgAnalyzer,
    isPrivate: true,
    exact: true
  },
];

export const getRouteConfig = (
  user: UserProfile | null | undefined,
  accountId?: string
) => {
  if (!user) return [];
  // employees
  if (UserUtils.isXGSUser(user) || UserUtils.isXGSAdministrator(user)){
      const routes = UserUtils.isXGSAdministrator(user)
        ? [...xgsUserRoutesComponents, ...rpgAnalyzerRouteComponent]
        : [...xgsUserRoutesComponents];
      if (UserUtils.canAccessFinancePayments(user)) {
        routes.push(...financePaymentRoutesComponents);
      }
      return routes;
    }
  // drivers
  if (UserUtils.isXGSDriver(user)) return xgsDriverRoutesComponents;
  // customers w/o accounts
  if (!user.subAccounts || user.subAccounts.length === 0 || !accountId) return customerWOPermissionsRoutesComponents;
  // customers w/ permission(s)
  let routesComponents: RoutesComponent[] = [];
  if (UserUtils.hasPermission(user, accountId, "VIEW")) {
    routesComponents.push(...customerViewRoutesComponents);
  }
  if (UserUtils.hasPermission(user, accountId, "RATE_QUOTE")) {
    routesComponents.push(...customerRateQuotesRoutesComponents);
  }
  if (UserUtils.hasPermission(user, accountId, "PAYMENT")) {
    routesComponents.push(...customerPaymentRoutesComponents);
  }
  return routesComponents;
};